import { TabPanel } from 'react-tabs';

export default TabPanel;
